<template>
  <el-table-column
    :key="code"
    :label="name"
    :min-width="200"
    :fixed="false"
    align="center"
  >
    <template
      slot-scope="scope"
    >
      <!-- 编辑模式 -->
      <ik-table-text
        v-show="edit"
        :ref="'input_' + scope.$index + '_' + 'code'"
        v-model="scope.row[code]"
        :line="scope.$index"
        :code="code"
        :name="name"
        :default-value="defaultValue"
        :min-length="minLength"
        :max-length="maxLength"
        :require="getRequire"
        :rules="rules"
        @onFieldChange="onFieldChange"
      />
      <!-- 显示模式   -->
      <span
        v-show="!edit"
      >
        <span>{{ scope.row[code] }}</span>
        <el-tooltip v-if="errorSign[scope.$index]" class="right" effect="dark" :content="message[scope.$index]" placement="top">
          <div>
            <i class="el-icon-warning" style="color:red;" />
          </div>
        </el-tooltip>
      </span>
    </template>
  </el-table-column>
</template>

<script>
import IkTableText from '@/components/ik/table/input/IkTableText'
export default {
  name: 'IkColumnText',
  components: {
    IkTableText
  },
  model: {
    // 属性
    prop: 'value',
    // 事件
    event: 'input'
  },
  props: {
    code: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    line: {
      type: Number,
      default: 0
    },
    value: {
      type: String,
      default: ''
    },
    edit: {
      type: Boolean,
      default: true
    },
    defaultValue: {
      type: String,
      default: ''
    },
    minLength: {
      type: Number,
      default: 0
    },
    maxLength: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    require: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: function() {
        return [
        ]
      }
    }
  },
  data() {
    return {
      errorSign: [],
      message: []
    }
  },
  computed: {
    getRequire() {
      return this.require
    }
  },
  methods: {
    onFieldChange(line, code, oldValue, value, errorSign, message) {
      this.$set(this.errorSign, line, errorSign)
      this.$set(this.message, line, message)
      this.$emit('onFieldChange', line, code, oldValue, value, errorSign, message)
    }
  }
}
</script>
<style scoped>
::v-deep.require> .el-input__inner{
    border: red 1px solid;
}
</style>
<style lang="scss" >
.el-form-item {
  margin-bottom: 12px;
  width: 100%;
}
.el-form-item__label {
  width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.el-form-item__content {
  width: calc(100% - 180px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
